export const SET_FULL_SCREEN = 'SET_FULL_SCREEN'
export const SET_MINI_PLAYER = 'SET_MINI_PLAYER'
export const SET_IS_PLAYING = 'SET_IS_PLAYING'
export const SET_MODE_TYPE = 'SET_MODE_TYPE'
export const SET_LIST_PLAYER = 'SET_LIST_PLAYER'
export const SET_SONG_DETAIL = 'SET_SONG_DETAIL'
export const SET_SONG_LYRIC = 'SET_SONG_LYRIC'
export const SET_DEL_SONG = 'SET_DEL_SONG'
export const SET_CURRENT_INDEX = 'SET_CURRENT_INDEX'
export const SET_CURRENT_TIME = 'SET_CURRENT_TIME'
export const SET_FAVORITE_SONG = 'SET_FAVORITE_SONG'
export const SET_FAVORITE_LIST = 'SET_FAVORITE_LIST'
export const SET_HISTORY_SONG = 'SET_HISTORY_SONG'
export const SET_HISTORY_LIST = 'SET_HISTORY_LIST'
